import { showToast } from '@/components/base/Toast';
import { updateList } from '@/mocks/home';

export default function UpdateTimeline() {
  return (
    <section id="updates" className="w-full border-t border-background-200 bg-background-100">
      <div className="w-full px-4 py-16 md:px-8 md:py-20">
        <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <div className="mb-4 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-history-line text-lg" />
              </span>
              <span className="text-xs font-medium uppercase tracking-[0.25em] text-secondary-600">
                Updates
              </span>
            </div>
            <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
              最近更新动态
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              资源持续更新，这里按时间倒序记录近期的写真集、cos视频与私拍套图上线与补档情况。
            </p>
            <button
              type="button"
              onClick={() => showToast('已订阅更新提醒（静态演示）')}
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors duration-200 hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-notification-3-line text-base" />
              订阅更新提醒
            </button>
          </div>

          <div className="lg:col-span-8">
            <ol className="relative border-l border-background-300 pl-6">
              {updateList.map((item) => (
                <li key={item.id} className="relative pb-7 last:pb-0">
                  <span className="absolute -left-[31px] top-1 flex h-3 w-3 items-center justify-center rounded-full border-2 border-background-100 bg-primary-500" />
                  <div className="flex flex-wrap items-center gap-3">
                    <span className="font-heading text-sm font-bold text-foreground-950">
                      {item.date}
                    </span>
                    <span className="rounded bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-900">
                      {item.type}
                    </span>
                  </div>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-700">{item.title}</p>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}